export const GET_PM_SCREEN = 'GET_PM_SCREEN'
export const SET_PM_SCREEN = 'SET_PM_SCREEN'
export const SET_PM_SCREEN_PROCESSING = 'SET_PM_SCREEN_PROCESSING'
export const RESET_PM_SCREEN = 'RESET_PM_SCREEN'
export const DELETE_PM_SCREEN = 'DELETE_PM_SCREEN'
export const SET_PM_SCREEN_ERROR = 'SET_PM_SCREEN_ERROR'

export function getPmScreen (options = {}) {
  const { screenType, language, sectionsLimit } = options
  return {
    type: GET_PM_SCREEN,
    payload: { screenType, language, sectionsLimit },
  }
}

export function deletePmScreen (screenType, language) {
  return {
    type: DELETE_PM_SCREEN,
    payload: { screenType, language },
  }
}

export function setPmScreen (screenType, language, data) {
  return {
    type: SET_PM_SCREEN,
    payload: {
      screenType,
      language,
      data,
    },
  }
}

export function setPmScreenProcessing (screenType, language, processing = true) {
  return {
    type: SET_PM_SCREEN_PROCESSING,
    payload: { screenType, language, processing },
  }
}

export function resetPmScreen (screenType, language) {
  return {
    type: RESET_PM_SCREEN,
    payload: { screenType, language },
  }
}

export function setPmScreenError (screenType, language, error) {
  return {
    type: SET_PM_SCREEN_ERROR,
    payload: {
      screenType,
      language,
      error,
    },
  }
}
